import {
  ChangeDetectorRef,
  CUSTOM_ELEMENTS_SCHEMA,
  ChangeDetectionStrategy,
  Component,
  Input,
} from '@angular/core';
import { PalantirButtonComponent } from '../button/button.component';
import { PalantirContentComponent } from '../content/content.component';
import { PalantirLayoutComponent } from '../layout/layout.component';
import { PalantirTextComponent } from '../text/text.component';
import { PalantirToolbarComponent } from '../toolbar/toolbar.component';
import { PalantirDialogRef } from './dialog-ref.service';

@Component({
  selector: 'palantir-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    PalantirContentComponent,
    PalantirTextComponent,
    PalantirButtonComponent,
    PalantirToolbarComponent,
    PalantirLayoutComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PalantirDialogComponent {
  @Input() public title?: string;

  public constructor(
    private readonly palantirDialogRef: PalantirDialogRef,
    private readonly changeDetectorRef: ChangeDetectorRef,
  ) {}

  public close() {
    void this.palantirDialogRef.close({ role: 'cancel' });

    this.changeDetectorRef.markForCheck();
  }
}
